import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-prose space-y-4">
      <h1 className="text-3xl font-semibold">Not found.</h1>
      <p>
        That route doesn't exist. <Link to="/">Back home →</Link>
      </p>
    </div>
  );
}
